import { Component, type ErrorInfo, type ReactNode } from "react";
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Application rendering error", {
      name: error.name,
      componentStack: info.componentStack,
    });
  }
  render() {
    return this.state.failed ? (
      <main className="grid min-h-screen place-items-center bg-ink p-6 text-white">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold">Something went wrong</h1>
          <p className="mt-3 text-slate-400">
            Refresh the page. If the problem continues, contact support without
            including sensitive information.
          </p>
          <ButtonReload />
        </div>
      </main>
    ) : (
      this.props.children
    );
  }
}
function ButtonReload() {
  return (
    <button
      className="mt-6 rounded-lg bg-brand px-4 py-2 font-semibold text-ink"
      onClick={() => window.location.reload()}
    >
      Reload application
    </button>
  );
}
